module.exports = __webpack_public_path__ + "static/media/category6.0587276c.png";